<style scoped>
.container {
  max-width: 1300px;
  margin: 0 auto;
  padding: 0 20px;
}

.image-banner {
  background-image: url(../assets/images/Group.png);
  background-size: contain;
  background-position: center;
  width: 400px;
  height: 400px;
  background-repeat: no-repeat;
}

.image-approach {
  background-image: url(../assets/images/approach.png);
  background-size: contain;
  background-position: center;
  width: 50%;
  background-repeat: no-repeat;
}

.last-image {
  background-image: url(../assets/images/Last.png);
  background-size: contain;
  background-position: center;
  width: 50%;
  background-repeat: no-repeat;
}

.banner-main {
  display: flex;
  padding: 3em 0;
}

.banner-main .container {
  display: flex
;
    align-items: center;
    width: 100%;
    justify-content: space-between;
}

.big-text {
  color: #1297ef;
  font-weight: 800;
  font-size: 60px;
  line-height: 100%;
  margin: 0px 0px 10px 0px;
}

.text-banner {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 2em;
  width: 48%;
  height: 400px;
}

.description-banner {
  line-height: 110%;
  margin: 10px 0px;
  font-size: 22px;
  font-weight: 300;
  color: #1e4d71;
}

.stats {
  display: flex;
  padding: 3em 0;
  align-items: flex-start;
  gap: 40px;
}

.item-stats {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.subtitle-stat {
  font-size: 22px;
  font-weight: 600;
  color: #1e4d71;
  line-height: 115%;
}

.goals {
  display: flex;
  flex-direction: column;
  padding: 3em 0;
}

.approach {
  margin: 3em 0;
  background: #d9eefd;
  padding: 3em 5em;
  border-radius: 20px;
}

.container-approach {
  display: flex;
  gap: 40px;
}

.approach-text {
  font-size: 22px;
  font-weight: 300;
  margin: 5px 0px;
}

.approach-text strong {
  font-size: 30px;
  font-weight: 800;
}

.container-text {
  width: 50%;
  display: flex;
  flex-direction: column;
}

.client {
  display: flex;
  padding: 3em 0;
  flex-direction: column;
}

.flex-box {
  display: flex;
  flex-direction: row;
  margin: 1em 0px;
  gap: 40px;
}

.approach-text-custom {
  width: 50%;
  margin: 2em 0px;
  padding: 0px 2em;
  font-size: 22px;
  font-weight: 300;
  line-height: 110%;
}

/* Tablet Responsive */
@media (max-width: 1024px) {
  .banner-main {
    padding: 2em 0;
  }

  .big-text {
    font-size: 48px;
  }

  .description-banner {
    font-size: 20px;
  }

  .stats {
    padding: 2em 0;
  }

  .stats .container {
    gap: 30px;
  }

  .approach {
    margin: 2em 0;
    padding: 2em 3em;
  }

  .client {
    padding: 2em 0;
  }
}

@media (max-width: 768px) {
  .banner-main .container {
    flex-direction: column;
  }

  .text-banner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 1em 0;
    width: 100%;
    height: auto;
  }

  .big-text {
    font-size: 36px;
  }

  .description-banner {
    font-size: 16px;
  }

  .stats .container {
    flex-direction: column;
    gap: 30px;
  }

  /* .image-banner {
    display: none;
  } */

  .banner-main {
    padding: 1em 0;
  }

  .item-stats {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    width: 100%;
  }

  .subtitle-stat {
    font-size: 18px;
    word-wrap: break-word;
  }

  .goals {
    padding: 1em 0;
  }

  .goals .description-banner {
    font-size: 16px !important;
  }

  .approach {
    margin: 1em 0;
    background: #d9eefd;
    padding: 1.5em;
    border-radius: 20px;
  }

  .container-approach {
    flex-direction: column;
  }

  .container-text {
    width: 100%;
  }

  .image-approach {
    width: 100%;
    height: 200px;
    margin-top: 20px;
  }

  .approach-text {
    font-size: 16px;
    font-weight: 300;
    margin: 5px 0px;
  }

  .client {
    padding: 1em 0;
  }

  .flex-box {
    display: flex;
    flex-direction: column;
    margin: 1em 0px;
    gap: 20px;
  }

  .last-image {
    width: 100%;
    height: 200px;
  }

  .approach-text-custom {
    width: 100%;
    margin: 0;
    padding: 0;
    font-size: 16px;
    font-weight: 300;
    line-height: 110%;
  }
}

@media (max-width: 480px) {
  .container {
    padding: 0 15px;
  }

  .big-text {
    font-size: 28px;
  }

  .description-banner {
    font-size: 14px;
  }

  .approach-text {
    font-size: 14px;
  }

  .approach-text-custom {
    font-size: 14px;
  }

  .subtitle-stat {
    font-size: 16px;
  }
}

.stats .container {
  display: flex;
  align-items: flex-start;
  gap: 40px;
}

.goals .container {
  display: flex;
  flex-direction: column;
}

.approach .container {
  display: flex;
  flex-direction: column;
}

.client .container {
  display: flex;
  flex-direction: column;
}
</style>
<template>
  <div>
    <section class="banner-main">
      <div class="container">
        <div class="image-banner"></div>
        <div class="text-banner">
          <span class="tiny-text">{{ $t('about.title') }}</span>
          <h1 class="big-text">{{ $t('about.bigText') }}</h1>
          <span class="description-banner">
            {{ $t('about.description') }}
          </span>
        </div>
      </div>
    </section>

    <section class="stats">
      <div class="container">
        <div class="item-stats">
          <h1 class="big-text">{{ $t('stats.projectsCompleted.bigText') }}</h1>
          <span class="subtitle-stat">{{ $t('stats.projectsCompleted.subtitle') }}</span>
          <span class="description-banner">{{ $t('stats.projectsCompleted.description') }}</span>
        </div>

        <div class="item-stats">
          <h1 class="big-text">{{ $t('stats.satisfaction.bigText') }}</h1>
          <span class="subtitle-stat">{{ $t('stats.satisfaction.subtitle') }}</span>
          <span class="description-banner">{{ $t('stats.satisfaction.description') }}</span>
        </div>

        <div class="item-stats">
          <h1 class="big-text">{{ $t('stats.recommendations.bigText') }}</h1>
          <span class="subtitle-stat">{{ $t('stats.recommendations.subtitle') }}</span>
          <span class="description-banner">{{ $t('stats.recommendations.description') }}</span>
        </div>
      </div>
    </section>

    <section class="goals">
      <div class="container">
        <h1 class="big-text">{{ $t('goals.title') }}</h1>
        <span class="description-banner" style="font-size: 22px">
          {{ $t('goals.description') }}
          <br />
          <br />
          {{ $t('goals.description2') }}
          <br />
          <br />
          {{ $t('goals.description3') }}
        </span>
      </div>
    </section>

    <section class="approach">
      <div class="container">
        <h1 class="big-text">{{ $t('approach.title') }}</h1>

        <div class="container-approach">
          <div class="container-text">
            <span class="approach-text">{{ $t('approach.innovation') }}</span>
            <br />
            <span class="approach-text">{{ $t('approach.customer') }}</span>
            <br />
            <span class="approach-text">{{ $t('approach.integration') }}</span>
            <br />
            <span class="approach-text">{{ $t('approach.growth') }}</span>
          </div>

          <div class="image-approach"></div>
        </div>
      </div>
    </section>

    <section class="client">
      <div class="container">
        <h1 class="big-text">
          {{ $t('know.title') }}
        </h1>
        <span class="approach-text">
          {{ $t('know.become') }}
        </span>
        <div class="flex-box">
          <div class="last-image"></div>
          <span class="approach-text-custom">
            {{ $t('know.knowtext') }}
          </span>
        </div>
        <span class="approach-text">
          {{ $t('know.transform') }}
        </span>
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import { useI18n } from 'vue-i18n'

export default {
  setup() {
    const { t } = useI18n() // Acceso a la función t() para traducir

    return {
      t,
    }
  },
}
</script>
